import React from "react";
import LoadingCircle from "./LoadingCircle";

const SectionTable = ({ 
  headers, 
  data, 
  loading, 
  renderRow, 
  emptyMessage = "No data found." 
}) => {
  return (
    <div className="w-full overflow-x-auto custom-scrollbar px-1"> 
      <table className="w-full text-left border-separate border-spacing-y-2">
        <thead>
          <tr className="bg-[#0F172A] text-[10px] font-black text-white/90 uppercase tracking-[0.2em]">
            {headers.map((header, index) => (
              <th 
                key={index} 
                className={`px-6 py-5 whitespace-nowrap ${
                  index === 0 ? "rounded-l-xl" : 
                  index === headers.length - 1 ? "rounded-r-xl" : ""
                } ${header.className || ""}`}
              >
                {header.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="text-stone-600 dark:text-stone-300">
          {loading ? (
            <tr>
              <td colSpan={headers.length} className="py-24 text-center">
                <div className="flex flex-col items-center justify-center space-y-4">
                  <LoadingCircle size="lg" />
                  <p className="text-[10px] font-black uppercase tracking-[0.2em] text-stone-400 animate-pulse">
                    Synchronizing Data...
                  </p>
                </div>
              </td>
            </tr>
          ) : data.length > 0 ? (
            data.map((item, index) => (
             <tr 
                key={item.id || index} 
                className={`
                  group transition-all duration-200 cursor-default relative z-0
                  /* Efek Hover: Perubahan background dan sedikit glow tanpa merubah ukuran */
                  hover:bg-blue-50/50 dark:hover:bg-blue-900/20 
                  ${
                    index % 2 !== 0 
                      ? "bg-stone-100/80 dark:bg-white/5" 
                      : "bg-white dark:bg-slate-900"
                  }
                `}
              >
                {renderRow(item, index)}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={headers.length} className="py-20 text-center text-slate-400 font-bold uppercase tracking-widest text-[10px]">
                {emptyMessage}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default SectionTable;